import { Chip } from '@mui/material';
import type { ConnectionStatus } from '@/api/types';

const MAP: Record<ConnectionStatus, { label: string; color: 'success' | 'warning' | 'default' }> = {
  active: { label: 'Active', color: 'success' },
  credential_expired: { label: 'Reconnect needed', color: 'warning' },
  revoked: { label: 'Revoked', color: 'default' },
};

export function StatusChip({ status }: { status: ConnectionStatus }) {
  const meta = MAP[status] ?? { label: status, color: 'default' as const };
  return <Chip size="small" label={meta.label} color={meta.color} variant="outlined" />;
}
